import { createBaseApi } from 'store/api';

export const apiConfig = {
  local: 'https://api-kube.gt.evoent.tech/',
  stage: 'https://api-kube.gt.evoent.tech/',
  prod: 'https://api-kube.evoplay.games/',
};

export const api = createBaseApi({
  apiConfig,
  reducerPath: 'tournamentService',
  tagTypes: ['TournamentResets'],
});
